<!--
    课件导航管理模块
    作用：显示与加载课件导航信息数据；
    实现：新增课件、加载课件场景、场景拖动排序、鼠标拖动宽度；
    组件：element->el-tree
    注释：WJ
-->
<template>
    <div
        class="block-box"
        :class="{
            'deep-black': true,
            'hide': !menuShow
        }"
        :style="!curIsCourse && menuShow && dragValue>0?`width:${104+dragValue}px`: null"
        @mouseover.stop="handleMouseEnterNav"
        @mouseleave.stop="handleMouseOutNav"
    >
        <div class="zhezhao" v-if="mulSelect"></div>
        <p class="add-box">
            <span class="title">课件导航</span>
            <span @click="onAdd" class="add">+</span>
            <!--<span class="add-icon el-icon-folder-add"></span>-->
        </p>
        <div class="block-btn">
            <div @mouseout.stop="handleMouseOutNavItem">
                <el-tree
                        class="tree2"
                        ref="tree2"
                        :data="blockData"
                        node-key="unique"
                        :draggable="true"
                        :props="defaultProps"
                        :default-expanded-keys="[$store.state.menusData.blocksSelected || '']"
                        @node-click="handleNodeClick"
                        @node-contextmenu="nodeContextmenu"
                        @node-drag-start="nodeDragStart"
                        @node-drag-end="nodeDragEnd"
                >
                    <span class="custom-tree-node"
                          slot-scope="{ node, data }">
                        <el-tooltip
                            class="item"
                            effect="light"
                            :content="node.label"
                            placement="right"
                            :open-delay="500"
                            :data-key="data.unique"
                            :class="{active: `${data.unique}` === `${$store.state.menusData.blocksSelected}`}"
                        >
                          <span class="label">{{ node.label }}</span>
                        </el-tooltip>
                    </span>
                </el-tree>
            </div>
        </div>
        <div id="drop-menu"
             class="drap-box"
             @mousedown="isDragDown = true"
        >
            <p v-if="isDragZhezhao" class="drap-zhezhao"></p>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    // import MulMenuItem from './components/mulMenuItem'
    export default {
        name: "blocks",
        components: {
            // MulMenuItem
        },
        props: {
            form: Array,
            selected: [Number, String],
            mouseEnterNav: Object,
            mouseEnterNavItem: Object,
            newDrapValue: [String, Number],
            menuShow: {
                type: Boolean,
                default: false
            },
            curIsCourse: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(['menusData', 'mulSelect', 'isBuildCocos']),
            blockData(){
                // const data = this.$store.state.menusData.blocksForm
                // const clearChild = arr => {
                //     arr.map(v=>{
                //         delete v.lesson
                //         if(v.children && v.children.length){
                //             v.children.map(q=>delete q.config)
                //         }
                //         if(v.leaf){
                //             clearChild(v.leaf)
                //         }
                //     })
                //     return arr
                // }
                // clearChild(data)
                return this.$store.state.menusData.blocksForm
            }
        },
        watch:{
            // blockData: {
            //     handler(newValue, oldValue){
            //         if(newValue && oldValue && newValue.length !== oldValue.length) {
            //             this.isShow = false
            //             setTimeout(() => {
            //                 this.isShow = true
            //             })
            //         }
            //     },
            //     deep: true,
            //     immediate: true
            // },
            // form:{
            //     handler(vl) {
            //         this.newForm = vl
            //     },
            //     deep: true,
            //     immediate: true
            // },
            // newForm:{
            //     handler(vl) {
            //         this.$emit('update:form', vl)
            //     },
            //     deep: true,
            //     immediate: true
            // },
            selected:{
                handler(vl) {
                    this.newSelected = vl
                    this.handlerSelected()
                },
                immediate: true
            },
            newSelected(vl){
                this.$emit('update:selected',vl)
            },
            mouseEnterNav(vl){this.newMouseEnterNav = vl},
            newMouseEnterNav(vl){this.$emit('update:mouseEnterNav',vl)},
            mouseEnterNavItem(vl){this.newMouseEnterNavItem = vl},
            newMouseEnterNavItem(vl){this.$emit('update:mouseEnterNavItem',vl)},
            newDrapValue(vl){this.dragValue = vl},
            dragValue(vl){this.$emit('update:newDrapValue',vl)}
        },
        mounted(){
            this.$nextTick(()=>{
                let div = document.getElementById('drop-menu')
                this.dragBox(div)
            })
        },
        data(){
            return {
                newMouseEnterNav: this.mouseEnterNav, // 鼠标移到导航上
                newMouseEnterNavItem: this.mouseEnterNavItem, // 鼠标移到导航上的元素
                newForm: this.form,
                newSelected: this.selected,
                defaultProps: {
                    children: 'leaf',
                    label: 'name'
                },
                isDragZhezhao: false,
                isDragDown: false,
                dragValue: 0,
                dragPopTop: 0,
                tempData: null // 临时数据
            }
        },
        methods: {
            // 设置选中类名
            handlerSelected(){
                    this.$nextTick(()=>{
                        const fn = setTimeout(()=>{
                            try {
                                let divCur = document.querySelector('.tree2 .el-tree-node.is-cur')
                                if(divCur && divCur.classList.contains('is-cur')) {
                                    divCur.classList.remove('is-cur')
                                }
                                let div = document.querySelector('.tree2 .el-tooltip.item.active')
                                div.parentElement.parentElement.parentElement.classList.add('is-cur')
                            } catch (e) {
                                console.log('设置选中类名==>', e)
                            }
                            clearTimeout(fn)
                        }, 100)
                    })
            },
            // 拖拽
            dragBox(drag) {

                const self = this

                drag.addEventListener("mousedown", function () {
                    self.isDragZhezhao = true
                }, false);

                let wrapLeft = 0
                document.addEventListener("mousedown", function () {
                    if(self.isDragDown){
                        wrapLeft = 0
                        console.log('left2==>', wrapLeft)
                    }
                }, false);

                document.addEventListener("mousemove", function (e) {
                    self.dragPopTop = e.clientY - 140
                    if (self.isDragDown === true) {
                        e.preventDefault()

                        let nowX = e.clientX,
                            disX = nowX - 104
                        console.log('disX==>', disX)

                        if(disX <= 0) disX = 0
                        if(disX >= 58) disX = 58
                        self.dragValue = disX
                    }
                    // 如果超出边界停止滑动
                    if(self.dragValue<0 || self.dragValue>58){
                        self.isDragDown = false
                        self.isDragZhezhao = false
                    }
                });

                document.addEventListener("mouseup", function () {
                    self.isDragDown = false
                    self.isDragZhezhao = false
                }, false);

            },
            setCurrentKey(){
                // console.log('优化速度==>setCurrentKey')
                // // if(this.$utils.isFastExecute(2000)) return false
                // const fn = setTimeout(()=>{
                //     this.$refs.tree2 && this.$refs.tree2.setCurrentKey(this.$store.state.menusData.blocksSelected)
                //     clearTimeout(fn)
                // }, 0)
            },
            setCurrentKey2(){
                this.$refs.tree2 && this.$refs.tree2.setCurrentKey(this.$store.state.menusData.blocksSelected)
            },
            handleNodeClick(data) {
                if(this.$utils.isFastExecute(500))return false
                // if(`${data.unique}` === `${this.menusData.blocksSelected}`) return false

                // 如果正在构建 禁止切换
                if(this.isBuildCocos){
                    return false
                }
                // 插入ppt 当前正在选择菜单，切换目录即清空选择菜单
                if(this.$store.state.is_global_select_menu &&
                    this.$store.state.menusData.blocksSelected !== data.unique){
                    this.$store.state.global_select_unique = ''
                }
                const {saving, isBuildCocos, isCocosSaving} = this.$store.state
                // 如果当前节点为叶子节点 刷新课程
                if(!data.leaf || (data.leaf && data.leaf.length<=0)){

                    const warn = '正在同步数据，请稍后'
                    if(saving || isBuildCocos || isCocosSaving){
                        this.$message.warning(warn)
                        return false
                    }
                    setTimeout(()=>{
                        // this.$store.dispatch('setIsBuilding', true)
                        //console.log('游戏共建中测试==>3')
                        if(this.menusData.lessonSelected)this.$store.state.isCocosSaving = true
                        this.newSelected = data.unique
                        // this.$store.dispatch('setBlocksSelected', data.unique)
                        this.$store.state.menusData.willGoBlock = data.unique
                        //console.time(`[耗时]从切换菜单到游戏渲染完成总耗时`)

                        this.handlerSelected()
                        this.$store.state.operationSteps = []
                        this.$emit('onBlocks', data)
                    })
                }else{
                    this.setCurrentKey2()
                }
            },
            nodeContextmenu(event, data, node, item){
                console.log(event.pageX, event, data, node, item);
                this.newMouseEnterNavItem = data
                setTimeout(()=>{
                    this.$emit('rightClick', {
                        ...event,
                        x: event.pageX,
                        y: event.pageY
                    })
                })
            },
            nodeDragStart(node){
                const data = this.$_.cloneDeepWith(this.menusData)
                this.tempData = data
                console.log('nodeDragStart==>', node, data)
                return false
            },
            nodeDragEnd(startNode, endNode, type, event){
                console.log('nodeDragEnd==>1', startNode, endNode, type, event)
                const data = this.$_.cloneDeepWith(this.tempData).blocksForm
                console.log('nodeDragEnd==>2', data, this.isOneMenu(data,startNode.data.unique), this.isOneMenu(data,endNode.data.unique))
                if(type === 'inner' || !this.isOneMenu(data, startNode.data.unique) || !this.isOneMenu(data, endNode.data.unique)){
                    this.$message.warning('只允许移动一级菜单进行顺序变更')
                    this.$store.state.menusData = this.tempData
                    this.tempData = null
                    return false
                }
                if(['before', 'after'].includes(type)) {
                    const operation = [{
                        node: 'leaf',
                        fromUnique: startNode.data.unique,
                        toUnique: endNode.data.unique,
                        operation: 'move',
                        position: type
                    }]
                    $eventBus.$emit('__save__', true, null, operation)
                }
            },
            // 判断当前菜单名称是否在一级菜单中
            isOneMenu(data, unique){
              let state = false
                try {
                    data.map(v=>{
                        if(`${v.unique}` === `${unique}`) state = true
                    })
                } catch (e) {
                    console.log('判断是否在一级菜单失败==>', e)
                }
              return state
            },
            // 添加导航
            onAdd(){
                let fn = ()=>{
                    console.log('retro lessonSelected15')
                    this.$store.state.menusData.lessonSelected = ''
                    this.$store.state.curForms = []
                    // 清空课件
                    $eventBus.$emit('onCurForm', [])
                }
                // 如果当前创建的是第一个导航，则默认创建第一个空页面
                // const blocksForm = this.$store.state.menusData.blocksForm
                let addPage = false
                // if(blocksForm && blocksForm.length === 0) addPage = true

                this.$emit('onAdd', {fn, addPage})
            },
            // 操作
            handleCommand(command, item, index) {
              console.log(command, item)
                switch (command) {
                    case 'edit':
                        this.$emit('onEdit', {index, ...item})
                        break
                    case 'delete':
                        this.$emit('onDelete', {index, ...item})
                        break
                    default:
                }
            },
            handleMouseEnterNav(){
              this.newMouseEnterNav = {nav:true}
            },
            handleMouseOutNav(){
                this.newMouseEnterNav = null
            },
            handleMouseEnterNavItem(item, index){
                this.newMouseEnterNavItem = {...item, index}
            },
            handleMouseOutNavItem(){
                this.newMouseEnterNavItem = null
            },
            // handleClickSelect(item,index){
            //     // if (this.$store.state.saving) {
            //     //     return false
            //     // }
            //     // console.log('选中导航==>', this.$_.cloneDeepWith(item), index)
            //     // // 选中索引 例如：'0-0-0' 则['0', '0-0', '0-0-0'] 都展开
            //     // this.newSelected = item.index || item.name.index
            //     // this.$emit('onBlocks', this.$_.cloneDeepWith(item),index)
            // },
            onAddBlocks(){
                this.$emit('onAddBlocks')
            }
        }
    }
</script>

<style lang="scss" scoped>
.tree2 /deep/ .el-tree-node.is-current .item{
    color: #BDBEC7;
}
.tree2 /deep/ .el-tree-node.is-current .el-tree-node__content{
    background-color: rgba(0,0,0,0);
}
.tree2 /deep/ .is-cur.is-focusable{
    background-color: #494B54 !important;
}
.block-btn /deep/ .el-tree{
    background-color: initial !important;
}
.block-btn .label{
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 78px;
    outline: none;
}
.block-btn /deep/ .el-tree-node__children .label{
    width: 54px;
}
.block-btn /deep/ .el-tree-node__children .el-tree-node__children .label{
    width: 40px;
}
.block-btn /deep/ .el-tree-node__content{
    height: 40px;
}
.block-btn /deep/ .el-tree-node.is-current.is-focusable > .el-tree-node__content{
    background-color: initial;
}
.block-btn /deep/ .el-tree-node.is-current.is-focusable > .el-tree-node__content .item{
    color: #BDBEC7;
}
.block-btn{
    font-size: 14px;
    height: calc(100vh - 94px);
    overflow-y: auto;
}
.block-box{
    width: 120px;
    height: 100%;
    box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.06);
    /*padding-bottom: 10px;*/
    user-select: none;
    transition: width .2s linear;
    position: relative;
    z-index: 1001;

    .zhezhao{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 10;
        cursor: not-allowed;
    }

    &.hide{
        width: 0px !important;
        overflow: hidden;
    }

    .drap-box{
        position: absolute;
        top: 0px;
        right: -6px;
        width: 6px;
        height: 100%;
        /*background-color: red;*/
        cursor: ew-resize;
        z-index: 10;

        &:hover{
            .block{
                display: inline-block;
            }
        }

        .drap-zhezhao{
            position: fixed;
            top: 0px;
            left: 0px;
            width: 100vw;
            height: 100vh;
            /*background-color: wheat;*/
            z-index: 999;
            /*display: none;*/
        }

        .block{
            position: absolute;
            left: 22px;
            top: 0px;
            width: 287px;
            background: #FFFFFF;
            border: 2px solid #FF2E00;
            padding: 8px;
            border-radius: 8px;
            display: none;

            &:before{
                position: absolute;
                top: 20px;
                left: -8px;
                content: '';
                width: 0px;
                height: 0px;
                border-top: 8px solid transparent;
                border-right: 10px solid white;
                border-bottom: 8px solid transparent;
                z-index: 2002;
            }
            &:after{
                position: absolute;
                top: 20px;
                left: -11px;
                content: '';
                width: 0px;
                height: 0px;
                border-top: 8px solid transparent;
                border-right: 10px solid #FF2E00;
                border-bottom: 8px solid transparent;
                z-index: 2001;
            }
        }
    }

    .add-box{
        width: 100%;
        text-align: left;
        font-size:14px;
        color:rgba(48,49,51,1);
        line-height:40px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .add {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: #303133;
            border-radius: 2px;
            line-height: 13px;
            color: white;
            font-size: 16px;
            text-align: center;
            margin-left: 14px;
            cursor: pointer;
            transition: background-color .2s linear;

            &:hover {
                /*background-color: #e7622e;*/
            }
        }

        .title {
            font-size: 14px;
            margin-left: 16px;
        }

        .add-icon{
            margin-left: 6px;
            font-size: 18px;
            cursor: pointer;
            position: relative;
            top: 2px;
        }
    }


    & .btn>.name{
        width: 77%;
        padding-left: 23%;
        font-size: 14px;
        display: flex;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .angle{
            width: 0px;
            height: 0px;
            border-width: 4px 4px 0;
            border-style: solid;
            border-color: #303133 transparent transparent;
            position: absolute;
            top: 20px;
            left: 10px;
            transform: rotateZ(-90deg);
            transition: all .2s linear;
        }

        &:hover{
            background-color: #F5F7FA;
        }
    }

    .block-btn > .block{
        height: 40px;
        overflow: hidden;
    }
    & .btn.active{
        height: initial;
        overflow: initial;
        & > .name {
            background-color: #e7622e;
            color: white;

            &>.angle{
                transform: rotateZ(0deg);
            }
        }
    }

    &.deep-black{
        width: 104px;
        background-color: #34353B;

        .add-box{
            .title{
                color: white;
                margin-left: 14px;
            }
            .add{
                color: #BDBEC7;
                margin-left: 6px;
            }
        }
        .block-btn{
            height: calc(100vh - 150px);
            overflow-x: hidden;
            .label{
                color: #BDBEC7;

                &.active{
                    color: #FF7838 !important;
                }
            }
        }
    }
}
</style>
